import { twMerge } from 'tailwind-merge';
import { useForm, useFormVersion } from '@witmetrics/data-store';
import {
  type PendingSubmission,
  useNewCase,
} from '@/providers/NewCaseProvider';
import Card from '@/components/Card';
import Title from '@/components/Title';
import IconButton from '@/components/IconButton';
import FormPreviewImage from '@/components/FormPreviewImage';
import { CloseIcon } from '@/icons';
import { classes, styles } from './utils';

export type SubmissionItemProps = {
  className?: string;
  submission: PendingSubmission;
  onEdit: (uuid: string) => void;
};

export default function SubmissionItem({
  className,
  submission: { uuid, versionId, answers },
  onEdit,
}: SubmissionItemProps) {
  const formVersion = useFormVersion(versionId);
  const form = useForm(formVersion?.formId);
  const { onRemovePendingSubmission } = useNewCase();

  return (
    <Card sx={styles.card} className={twMerge(classes.card, className)}>
      <button
        className={classes.content}
        type="button"
        onClick={() => onEdit(uuid)}>
        <FormPreviewImage
          className={classes.preview}
          versionId={versionId}
          answers={answers}
        />
        <div className={classes.details}>
          <Title className={classes.title} size="xs">
            {form?.name || 'Form'}
          </Title>
        </div>
      </button>
      <IconButton onClick={() => onRemovePendingSubmission(uuid)}>
        <CloseIcon className={classes.closeIcon} />
      </IconButton>
    </Card>
  );
}
